import type { CSSProperties } from 'react'

export const formBoxStyles: CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
}
